<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="list"
      item-key="id"
      show-expand
      class="elevation-0 data-table"
    >
      <template v-slot:body="{ items }">
        <tbody v-for="item in items" :key="item.id">
          <tr class="data-table__row">
            <td />
            <td>
              {{ item.title }}
            </td>
            <td>
              {{ item.code }}
            </td>
            <td>
              {{ item.start_date }}
            </td>
            <td>
              {{ item.end_date }}
            </td>

            <td class="text-center nowrap">
              <Actions
                hide-duplicate
                :path="`/internal_projects/${item.id}`"
                @destroy="$emit('destroy', item)"
              >
              </Actions>
            </td>
          </tr>
        </tbody>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    headers() {
      return [
        {
          text: "Title",
          align: "start",
          value: "title",
        },
        {
          text: "Code",
          align: "start",
          value: "code",
        },
        {
          text: "Start Date",
          align: "start",
          value: "start_date",
        },
        {
          text: "End Date",
          align: "start",
          value: "end_date",
        },
        {
          text: "Actions",
          align: "center",
          sortable: false,
        },
      ];
    },
  },
};
</script>

<style></style>
